import { csrfToken, ErrorSwal } from "../app";

export const toggleBetweenElements = (
  element1,
  element2,
  speed = 500,
  callbackFn,
) => {
  $(element1).fadeOut(speed / 2, () => {
    $(element2).fadeIn(speed / 2, callbackFn);
  });
};

$(".number-stepper").on("click", function (e) {
  const btn = $(e.target);
  const action = btn.data("action");
  const input = btn.parent().find("input");
  const inputVal = parseInt(input.val()) || 0;
  const step = parseInt(input.attr("step")) || 1;
  const min = parseInt(input.attr("min")) || 0;
  const max = parseInt(input.attr("max")) || Infinity;

  let newVal;
  if (action === "plus") {
    newVal = inputVal + step;
  } else if (action === "minus" && inputVal > min) {
    newVal = inputVal - step;
  }

  if (newVal >= min && newVal <= max) {
    input.val(newVal);
  } else if (newVal < min) {
    input.val(min);
  } else if (newVal > max) {
    input.val(max);
  }

  input.trigger("change");
});

$(".toggle-secret").on("click", function (e) {
  e.preventDefault();
  const btn = $(e.currentTarget);
  const input = $(e.currentTarget).parent().find("input");

  if (btn.data("action") === "show") {
    input.attr("type", "text");
    btn.html('<i class="fas fa-eye-slash"></i>');
    btn.data("action", "hide");
  } else {
    input.attr("type", "password");
    btn.html('<i class="fas fa-eye"></i>');
    btn.data("action", "show");
  }
});

export const ajaxPost = (url, data, form = null) => {
  // before post actions
  if (form) {
    $(form).find(".alertWrapper").remove();
    $(form).find(".is-invalid").removeClass("is-invalid");
    $(form).find(".invalid-feedback").remove();
    $(form).find("button[type=submit]").attr("disabled", "disabled");
  }

  // add csrf token to data
  if (typeof data === "undefined") {
    // sourcery skip: dont-reassign-parameters
    data = { name: "csrfmiddlewaretoken", value: csrfToken };
  } else if (Array.isArray(data)) {
    data.push({ name: "csrfmiddlewaretoken", value: csrfToken });
  } else if (typeof data === "object") {
    data["csrfmiddlewaretoken"] = csrfToken;
  }

  return new Promise((resolve, reject) => {
    $.post(url, data, (response) => {
      resolve(response);
    })
      .fail((response) => {
        if (response.status >= 500) {
          if (response.responseJSON) {
            let responseJson = response.responseJSON;
            let errorText = "";
            if (response.responseJSON["event_id"]) {
              errorText = `Sorğu kodu: ${response.responseJSON["event_id"]}`;
              responseJson["event_id"] = errorText;
            } else {
              const errorList = parceAjaxErrorResponse(responseJson);
              if (errorList.length > 0) {
                errorText = errorList.join("<br>");
              }
            }
            ErrorSwal.fire({ html: errorText }).then(() => {});
            reject(responseJson);
          }

          ErrorSwal.fire({}).then(() => {
            console.log("Server error", response);
          });

          if (response.status === 502) {
            reject("Xahiş olunur bir az sonra yenidən cəhd edəsiniz.");
          }

          reject(
            "Server xətası. Xahiş olunur bir az sonra yenidən cəhd edəsiniz.",
          );
        }
        if (response.status === 404) {
          ErrorSwal.fire({}).then(() => {
            console.log("Page not found error", response);
          });
          reject("Əməliyyat uğursuz oldu. Səhifə tapılmadı.");
        }
        if (response.status === 403) {
          ErrorSwal.fire({
            icon: "error",
            titleText: "Xəta!",
            text: "Bu əməliyyatı icra etmək üçün icazəniz yoxdur.",
          }).then(() => {
            console.log("Permission denied error", response);
          });
          reject("Bu əməliyyatı icra etmək üçün icazəniz yoxdur.");
        }
        // custom http status code for csrf token error
        if (response.status === 463) {
          ErrorSwal.fire({
            icon: "warning",
            position: "center",
            text: "CSRF Token yoxlamanı keçmədi. Xahiş olunur səhifəni yeniləyəsiniz. Bu kömək olmasa brovserinizdə cookie-lərin yazılmasına icazə verin.",
          }).then(() => {
            console.log("CSRF validation error", response);
          });
        }
        // custom http status code for http redirect
        if (response.status === 464) {
          console.log("Redirecting to", response.responseJSON["redirect_url"]);
          window.location.href = response.responseJSON["redirect_url"];
          reject("Səhifə yönləndirilir...");
        }
        reject(response.responseJSON);
      })
      .always(() => {
        // after post actions
        if (form) {
          $(form).find("button[type=submit]").removeAttr("disabled");
          $(form).find(".kms-loading").remove();
        }
      });
  });
};

export const ajax = (url, formData, form = null) => {
  // before post actions
  if (form) {
    $(form).find(".alertWrapper").remove();
    $(form).find(".is-invalid").removeClass("is-invalid");
    $(form).find(".invalid-feedback").remove();
    $(form).find("button[type=submit]").attr("disabled", "disabled");
  }

  // add csrf token to data
  formData.append("csrfmiddlewaretoken", csrfToken);

  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      type: "POST",
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      success: (response) => {
        resolve(response);
      },
      error: (response) => {
        if (response.status >= 500) {
          if (response.responseJSON) {
            let responseJson = response.responseJSON;
            let errorText = "";
            if (response.responseJSON["event_id"]) {
              errorText = `Sorğu kodu: ${response.responseJSON["event_id"]}`;
              responseJson["event_id"] = errorText;
            } else {
              const errorList = parceAjaxErrorResponse(responseJson);
              if (errorList.length > 0) {
                errorText = errorList.join("<br>");
              }
            }
            ErrorSwal.fire({ html: errorText }).then(() => {});
            reject(responseJson);
          }

          ErrorSwal.fire({}).then(() => {
            console.log("Server error", response);
          });

          if (response.status === 502) {
            reject("Xahiş olunur bir az sonra yenidən cəhd edəsiniz.");
          }

          reject(
            "Server xətası. Xahiş olunur bir az sonra yenidən cəhd edəsiniz.",
          );
        }
        if (response.status === 404) {
          ErrorSwal.fire({}).then(() => {
            console.log("Page not found error", response);
          });
          reject("Əməliyyat uğursuz oldu. Səhifə tapılmadı.");
        }
        if (response.status === 403) {
          ErrorSwal.fire({}).then(() => {
            console.log("Permission denied error", response);
          });
          reject("Bu əməliyyatı icra etmək üçün icazəniz yoxdur.");
        }
        // custom http status code for csrf token error
        if (response.status === 463) {
          ErrorSwal.fire({
            icon: "warning",
            position: "center",
            text: "CSRF Token yoxlamanı keçmədi. Xahiş olunur səhifəni yeniləyəsiniz. Bu kömək olmasa brovserinizdə cookie-lərin yazılmasına icazə verin.",
          }).then(() => {
            console.log("CSRF validation error", response);
          });

          reject();
        }
        // custom http status code for http redirect
        if (response.status === 464) {
          console.log("Redirecting to", response.responseJSON["redirect_url"]);
          window.location.href = response.responseJSON["redirect_url"];
          return "Səhifə yönləndirilir...";
        }

        reject(response.responseJSON);
      },
      complete: () => {
        // after post actions
        if (form) {
          $(form).find("button[type=submit]").removeAttr("disabled");
          $(form).children(".kms-loading").hide();
        }
      },
    });
  });
};

export const parceAjaxErrorResponse = (errors) => {
  let errorList = [];
  const getErrorText = (errors) => {
    if (errors && typeof errors === "object") {
      for (const key of Object.keys(errors)) {
        if (key) {
          getErrorText(errors[key]);
        }
      }
    } else if (errors) {
      errorList.push(errors);
    }
    return errorList;
  };

  if (!errors) {
    errorList.push(
      "Serverə sorğu zamanı xəta baş verdi. Xahiş olunur az sonra yenə cəhd edəsiniz",
    );
  } else {
    getErrorText(errors);
  }

  return errorList;
};

export const bsAlert = (options) => {
  const optionsDefault = {
    parent: "body",
    message: "",
    type: "danger",
    scroll: true,
    shake: true,
    place: "prepend",
  };

  // sourcery skip: dont-reassign-parameters
  options = { ...optionsDefault, ...options };

  let shakeClass = "" ? options.shake : "shake";

  options.message = parceAjaxErrorResponse(options.message).join("<br>");

  const alert = [
    `<div class="alertWrapper alert alert-${options.type} alert-dismissible pb-2 ${shakeClass}" role="alert">`,
    ` <div class="mb-2"><strong>Xəta!</strong></div>`,
    ` <div class="mb-2">${options.message}</div>`,
    ` <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>`,
    `</div>`,
  ].join("");

  if (options.place === "prepend") {
    $(options.parent).prepend(alert);
  } else {
    $(options.parent).append(alert);
  }

  if (scroll) {
    const scrollElement = $(options.parent).find(".alertWrapper")[0];
    $("html, body").animate({ scrollTop: scrollElement.offsetTop - 50 }, 100);
  }
};

export const ajaxErrorAlert = (errors, form) => {
  const generalErrors = [];
  let lastErrorElement = null;
  if (typeof errors === "string") {
    // sourcery skip: dont-reassign-parameters
    errors = [errors];
  }
  for (let error in errors) {
    const formElement = form.find(
      `input[name=${error}]:visible, select[name=${error}], textarea[name=${error}]`,
    );
    if (formElement.length > 0) {
      formElement.addClass("is-invalid");
      let parentDiv = formElement.parent("div");
      parentDiv.children(".invalid-feedback").remove();
      parentDiv.append(
        Array.isArray(errors[error])
          ? `<div class="invalid-feedback">${errors[error].join("<br>")}</div>`
          : `<div class="invalid-feedback">${errors[error]}</div>`,
      );
      lastErrorElement = formElement[0];
    } else {
      generalErrors.push(errors[error]);
    }
  }

  if (generalErrors.length > 0) {
    const alertWrapperParent = $(form).find("#alertWrapperParent");
    if (alertWrapperParent.length > 0) {
      bsAlert({ parent: alertWrapperParent, message: generalErrors });
    } else {
      bsAlert({ parent: form, message: generalErrors });
    }
  } else if (lastErrorElement) {
    lastErrorElement.focus();
  }
};
